import React from 'react';
import { Image } from '@landing/ui';
import { useStateModal } from 'utils/hooks';
import { PlayerModal } from '@landing/modals';

import * as styles from './Slide.module.scss';

export default function Slide({ poster, youtubeVideo }) {
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <>
      <div className={styles.slide} role="button" onClick={showModal}>
        <Image className={styles.picture} classImage={styles.img} src={poster} alt={poster?.alt} />
      </div>
      <PlayerModal
        isOpen={modalState.isOpen}
        closeModalCallback={hideModal}
        data={{
          videoSrc: youtubeVideo,
          videoType: 'youtube',
          autoplay: true,
        }}
      />
    </>
  );
}
